import { useMedia } from '@dnb/eufemia/shared';
import { PinnedAndRecentPagesView } from '@portals/shared-frontend/components';
import useLocalStorage from '@portals/shared-frontend/hooks/useLocalStorage';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import { GlobalSearch } from '@/components/NavigationBar/GlobalSearch/GlobalSearch';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { useUser } from '@/hooks/useUser';

import DeveloperLogo from '../DeveloperLogo';
import MobileBurgerButton from './MobileBurgerButton';
import NavigationButton from './NavigationButton';
import NavigationButtonMenu from './NavigationButtonMenu';
import RecentlyVisitedButton from './RecentlyVisitedButton';
import RecentPagesDropdown from './RecentPagesDropdown';

import style from './index.module.css';

export enum openMenu {
  ProfileDropDown = 'ProfileDropDown',
  BurgerNavigationMenu = 'BurgerNavigationMenu',
  RecentlyVisited = 'RecentlyVisited',
  none = '',
}

const RECENTLY_VISITED_STORAGE_KEY = 'recently_visited_panel_open';

export default function NavigationBar() {
  const { isLarge } = useMedia();
  const { isLoading } = useUser();
  const [whichMenuIsOpen, setWhichMenuIsOpen] = useState<openMenu>(openMenu.none);
  const { featureFlags } = useFeatureFlags();
  const [showRecentlyVisited, setShowRecentlyVisited] = useLocalStorage(RECENTLY_VISITED_STORAGE_KEY, false);

  const showProfileMenu = whichMenuIsOpen !== openMenu.BurgerNavigationMenu;
  const showBurgerNavigationMenu = whichMenuIsOpen !== openMenu.ProfileDropDown;
  const showDivider = whichMenuIsOpen !== openMenu.BurgerNavigationMenu;

  const bgColor = useMemo(
    () => (featureFlags.ENABLE_ENV_COLOR_INDICATOR ? 'bg-accent-yellow-30' : 'bg-white'),
    [featureFlags.ENABLE_ENV_COLOR_INDICATOR],
  );

  return (
    <div className={classNames(bgColor, style['NavigationHeader'])}>
      <div className={style['NavigationBar']}>
        <div className={style['NavigationMenu']}>
          <div className={style['Logo']}>
            <Link to="/">
              <DeveloperLogo />
            </Link>
          </div>
          {isLarge && <NavigationButtonMenu />}
        </div>
        <div className={style['ActionMenu']}>
          <div className={style['GlobalSearch']}>
            <GlobalSearch />
          </div>
          <RecentlyVisitedButton
            isActive={showRecentlyVisited && !isLoading}
            setShowRecentlyVisited={setShowRecentlyVisited}
          />
          {showProfileMenu && (
            <NavigationButton isProfileMenu setWhichMenuIsOpen={setWhichMenuIsOpen} title="LoginButton" />
          )}
          {!isLarge && showBurgerNavigationMenu && (
            <>
              {showDivider && <div className={style['ProfileDivider']} />}
              <MobileBurgerButton setWhichMenuIsOpen={setWhichMenuIsOpen} />
            </>
          )}
        </div>
      </div>
      <div className={style['RecentlyVisited']} data-visible={showRecentlyVisited && !isLoading ? 'true' : 'false'}>
        {/* p-1 -m-1 is added so that the outline is shown correctly given the overflow-auto */}
        <div className="flex-1 p-1 -m-1 overflow-x-auto [scrollbar-width:thin] [scrollbar-color:var(--color-mint-green-50)_transparent]">
          <PinnedAndRecentPagesView />
        </div>
        <RecentPagesDropdown />
      </div>
    </div>
  );
}
